<template>
  <div>
    <i
      class="fa fa-eye"
      style="color: #832e5b; cursor: pointer"
      title="View Applicant Details"
      @click="openModal"
    ></i>
  </div>
</template>

<script>
export default {
  name: "ApplicantPreviewModalLink",
  methods: {
    openModal() {
      if (
        this.params &&
        this.params.context &&
        this.params.context.componentParent
      ) {
        this.params.context.componentParent.showApplicantModal(
          this.params.data.id
        );
      }
    },
  },
};
</script>
